import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import axiosInstance, { API_URL } from "../../../../Utils/url";
import ViewTemplates from "../../components/view";

const InsuranceViewCard = ({ open, onClose, rowId }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchInsurencetypeById();
  }, [rowId]);
  const fetchInsurencetypeById = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/insurance-configuration/${rowId}/`
      );

      const success = response?.data?.success;
      const data = response?.data?.data;
      setData(data);
    } catch (err) {
      setData([]);
    } finally {
    }
  };

  console.log(data,"data");
  

  return (
    <ViewTemplates open={open} onClose={onClose} rowId={rowId} title={"Insurence"}>
         hfagsdfghjmk,l.;/''
    </ViewTemplates>
  );
};

export default InsuranceViewCard;
